$mol_icon_align_vertical_distribute $mol_icon path \M22 2V4H2V2H22M7 10.5V13.5H17V10.5H7M2 20V22H22V20H2Z
